export const getDqMemoKey = (dqKey: string) => 'DQ:' + dqKey
export const MEMO_KEY_PERS = 'PERS'
export const MEMO_KEY_KOST = 'KOST'
export const MEMO_KEY_SWITCH_USER = 'KEY_SWITCH_USER'
